import React from 'react';
import styles from './../CardsList.module.less';

export type EcmBaseCardProps = {
  title: string;
  subTitle?: string;
  description?: string;
  titleStyles?: React.CSSProperties;
};

type BaseCardProps = {
  ecmContent: EcmBaseCardProps;
};

const BaseCard: React.FC<BaseCardProps> = ({ ecmContent }) => {
  const { title, subTitle, description, titleStyles: ecmTitleStyles = {} } = ecmContent;

  return (
    <div>
      {title && (
        <p className={styles.card_title} style={{ ...ecmTitleStyles }}>
          {title}
        </p>
      )}
      {subTitle && <p className={styles.card_subtitle}>{subTitle}</p>}
      {description && <p className={styles.card_description}>{description}</p>}
    </div>
  );
};

export default BaseCard;
